module.exports = __webpack_public_path__ + "static/media/87.205416e5.png";